/// <reference types="@yandex-int/error-counter/dist/implementation.d.ts" />
// Запись выше подтягивает типы для интерфейса 'LogErrorInitSettings' ниже
export type InitErrorBoosterConfig = Ya.Rum.LogErrorInitSettings;

export const initErrorBooster = (config: InitErrorBoosterConfig) => {
    require('@yandex-int/error-counter/dist/interfaceOverRum');
    require('@yandex-int/error-counter/dist/implementation');
    require('@yandex-int/error-counter/dist/filters');
    require('@yandex-int/error-counter/dist/logError');
    require('@yandex-int/error-counter/dist/logAjaxError');

    Ya.Rum.initErrors(config);
};
